import { render, staticRenderFns } from "./Form1_Persona1.vue?vue&type=template&id=7c527ef5&"
import script from "./Form1_Persona1.vue?vue&type=script&lang=js&"
export * from "./Form1_Persona1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c527ef5')) {
      api.createRecord('7c527ef5', component.options)
    } else {
      api.reload('7c527ef5', component.options)
    }
    module.hot.accept("./Form1_Persona1.vue?vue&type=template&id=7c527ef5&", function () {
      api.rerender('7c527ef5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Flujo/Formularios/Formularios1/ES/Persona/Form1_Persona1.vue"
export default component.exports